export default "__VITE_ASSET__6e09a726__"